export type SelectableOption<T> = {
  label: string,
  value: T,
}
export const toSelectableOption = <T extends any>(option: T, label: string): SelectableOption<T> => {
  return {label: label, value: option};
};
